import { Text } from '@leroy-merlin-br/backyard-react'
import { Checkbox } from '@backyard-ui/core'

import * as S from './styled'

type Props = {
  optionLabel: string
  quantity?: number
  selected: boolean
  onFilterClick: () => void
  rightSpacing: number
}

const OptionFilterItem = ({
  optionLabel,
  quantity,
  selected,
  onFilterClick,
  rightSpacing
}: Props) => (
  <S.CheckboxWrapper
    title={optionLabel}
    rightSpacing={rightSpacing}
  >
    <Checkbox name="prices" isChecked={selected} onChange={onFilterClick}>
      <Text as="span" size="mega" color="n700" noMargin>
        {optionLabel}{' '}
      </Text>
      <Text as="span" size="kilo" color="n700" noMargin>
        {quantity && `(${quantity})`}
      </Text>
    </Checkbox>
  </S.CheckboxWrapper>
)
export default OptionFilterItem
